<div class="tab-content match-summary live-timeline">
    <div class="py-2 pl-2">
        <span class="second-service">CHA</span> {{ 'web.is_checkout_attempt' | translate }}
        <span class="match-ball">B</span> {{ 'web.is_bust' | translate }}
    </div>
    @if (data.firstThrow) {
    <div class="tab-pane show active">
        <h6 class="text-center text-uppercase match-summary__head">
            {{ 'web.' + sportName + '_first_throw' | lowercase | translate }}
        </h6>
        <div class="row no-gutters border-top py-1 px-3 small">
            <div class="col-5 align-self-center font-weight-bold font-1x text-left">
                @if (data.firstThrow === 'home') { &nbsp;@if (data.image) {
                <img [src]="data.image + '?color=' + color" height="13" />
                }&nbsp;{{ data.home }}
                }
            </div>
            <div class="col-2 align-self-center font-weight-bold text-center font-1-1x">&nbsp;</div>
            <div class="col-5 align-self-center font-weight-bold font-1x text-right">
                @if (data.firstThrow === 'away') {
                {{ data.away }} &nbsp;@if (data.image) {
                <img [src]="data.image + '?color=' + color" height="13" />
                }&nbsp; }
            </div>
        </div>
    </div>
    } @for (leg of data.data; track $index) {
    <div class="tab-pane show active">
        <h6 class="text-center text-uppercase match-summary__head">
            {{ 'web.' + sportName + '_leg' | lowercase | translate }}
        </h6>
        @for (action of leg.score; track $index; let isLastMain = $last) {
        <div class="row no-gutters border-top py-1 px-0 small" style="overflow: hidden">
            <div class="col-5 align-self-center font-weight-bold font-0-8x font-md-0-9x px-1 text-right">
                @if (action.darts[0]?.competitor === 'home') { @for (point of action.darts; track $index; let isLast =
                $last) {
                {{ point.dart_score_total }}
                <small>({{ point.dart_score_multiplier }}x{{ point.dart_score }})</small>
                @if (point.is_bust) {
                <span class="match-ball" title="{{ 'web.is_bust' | translate }}">B</span>
                } @if (point.is_checkout_attempt) {
                <span class="double-fault font-0-8x p-0" title="{{ 'web.is_checkout_attempt' | translate }}">CHA</span>
                } @if (!isLast) { , } } }
            </div>
            <div class="col-2 align-self-center font-weight-bold text-center font-1x">
                <span [class.emph-text-node]="action.isHomeWinner">{{ action.homeScore }}</span>
                -
                <span [class.emph-text-node]="action.isHomeWinner">{{ action.awayScore }}</span>
            </div>
            <div class="col-5 align-self-center font-weight-bold font-0-8x font-md-0-9x px-1 text-left">
                @if (action.darts[0]?.competitor === 'away') { @for (point of action.darts; track $index; let isLast =
                $last) {
                {{ point.dart_score_total }}
                <small>({{ point.dart_score_multiplier }}x{{ point.dart_score }})</small>
                @if (point.is_bust) {
                <span class="match-ball" title="{{ 'web.is_bust' | translate }}">B</span>
                } @if (point.is_checkout_attempt) {
                <span class="double-fault font-0-8x p-0" title="{{ 'web.is_checkout_attempt' | translate }}">CHA</span>
                } @if (!isLast) { , } } }
            </div>
        </div>
        } @if (leg.lastDarts?.length > 0) {
        <div class="row no-gutters border-top py-1 px-3 small">
            <div
                class="col-12 align-self-center font-0-9x"
                [class.text-right]="leg.lastDarts[0]?.competitor === 'away'"
                [class.text-left]="leg.lastDarts[0]?.competitor === 'home'"
            >
                @for (point of leg.lastDarts; track $index; let isLast = $last) {
                {{ point.dart_score_total }}
                <small>({{ point.dart_score_multiplier }}x{{ point.dart_score }})</small>
                @if (point.is_bust) {
                <span class="match-ball" title="{{ 'web.is_bust' | translate }}">B</span>
                } @if (point.is_checkout_attempt) {
                <span class="double-fault font-0-8x p-0" title="{{ 'web.is_checkout_attempt' | translate }}">CHA</span>
                } @if (!isLast) { , } }
            </div>
        </div>
        }
        <div class="row no-gutters border-top py-1 px-3 small">
            <div class="col-3 align-self-center font-weight-bold font-1x text-right">
                &nbsp; @if (leg.result === 'home') {
                <img [src]="data.image + '?color=' + color" height="13" />
                }
            </div>
            <div class="col-6 align-self-center font-weight-bold text-center font-1-2x">
                <span [class.emph-text-node]="leg.result === 'home'">{{ leg.home_score }}</span>
                -
                <span [class.emph-text-node]="leg.result === 'away'">{{ leg.away_score }}</span>
            </div>
            <div class="col-3 align-self-center font-weight-bold font-1x text-left">
                &nbsp; @if (leg.result === 'away') {
                <img [src]="data.image + '?color=' + color" height="13" />
                }
            </div>
        </div>
    </div>
    }
</div>
